export default __webpack_public_path__ + "static/media/2425 knife block A side.d29a5c72.png";